// extracted by mini-css-extract-plugin
export var content = "_5h-3";
export var list = "_5h-4";
export var settingsContent = "_5h-7";
export var settingsPanel = "_5h-8";
export var state = "_5h-6";
export var triggerBadge = "_5h-2";
export var triggerButton = "_5h-1";
export var triggerShell = "_5h-0";
export var unreadDot = "_5h-5";